import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import displayProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import { ProductFiltersExtended } from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListIsStockAvailableReducer";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => ({
    selectedWarehouse: state.context.session.pickUpWarehouse,
    currentState: state.WhiteCap.productListIsStockAvailableStore.productFiltersExtended.isInStockAtBranch,
});

const mapDispatchToProps = {
    displayProducts,
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductListViewSelectStyles {
    branchesGridItem?: GridItemProps;
    headingText?: TypographyPresentationProps;
    isStockCheckbox?: CheckboxPresentationProps;
}

export const viewSelectStyles: ProductListViewSelectStyles = {
    branchesGridItem: {
        width: 12,
        css: css`
            display: block;
            padding: 0;
        `,
    },
    headingText: {
        size: 16,
        lineHeight: "24px",
        weight: 700,
        css: css`
            margin-bottom: 16px;
        `,
    },
    isStockCheckbox: {
        css: css`
            margin-bottom: 10px;
        `,
    },
};

const styles = viewSelectStyles;

const ProductListStock: FC<Props> = ({ addProductFilters, removeProductFilters, selectedWarehouse, currentState }) => {
    const label = translate("View Inventory");
    const description = selectedWarehouse?.description || "";
    const wareHouseLabelPart = description.includes("-") ? description.split("-")[1].trim() : "Branch";
    const wareHouseLabel = translate(`${wareHouseLabelPart}`);

    const onChangeFacet: CheckboxProps["onChange"] = (_, value) => {
        if (value) {
            addProductFilters({ isInStockAtBranch: true } as ProductFiltersExtended);
        }
        else {
            removeProductFilters({ isInStockAtBranch: false } as ProductFiltersExtended);
        }
    };


    return (
        <GridItem {...styles.branchesGridItem}>
            <Typography variant="body" as="span" {...styles.headingText}>
                {label}
            </Typography>
            <CheckboxGroup>
                <Checkbox checked={currentState} onChange={onChangeFacet} {...styles.isStockCheckbox}>
                    <Typography>
                        {translate("Available at ")}
                        <Typography as="span" color="#2F63B0">
                            {wareHouseLabel}
                        </Typography>
                    </Typography>
                </Checkbox>
            </CheckboxGroup>
        </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListStock),
    definition: {
        group: "Product List",
        displayName: "Is Stock",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;